import { Button } from "primereact/button";
import type TooltipOptions from "primereact/tooltip/tooltipoptions";
import { useCallback } from "react";
import { useFragment, useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type createIhkCertificateRewardButton_AddIHKCertificateRewardMutation } from "@relay/createIhkCertificateRewardButton_AddIHKCertificateRewardMutation.graphql";
import { type createIhkCertificateRewardButton_TreeNodeFragment$key } from "@relay/createIhkCertificateRewardButton_TreeNodeFragment.graphql";
import {
	ADD_IHK_CERTIFICATE_REWARD_MUTATION,
	TREE_NODE_FRAGMENT,
} from "./create-ihk-certificate-reward-button.graphql";
import { type CreateIHKCertificateRewardButtonProps } from "./create-ihk-certificate-reward-button.types";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

export const CreateIHKCertificateRewardButton = ({
	disabled,
	treeNodeFragmentRef,
}: CreateIHKCertificateRewardButtonProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const node = useFragment<createIhkCertificateRewardButton_TreeNodeFragment$key>(
		TREE_NODE_FRAGMENT,
		treeNodeFragmentRef,
	);

	const [addIHKCertificateReward, isAddingIHKCertificateReward] =
		useMutation<createIhkCertificateRewardButton_AddIHKCertificateRewardMutation>(
			ADD_IHK_CERTIFICATE_REWARD_MUTATION,
		);

	const tooltipOptions: TooltipOptions.TooltipOptions = { showOnDisabled: true, position: "top" };
	const handleOnClick = useCallback(() => {
		addIHKCertificateReward({
			variables: {
				input: {
					contentId: node.id,
				},
			},
			updater: setDraft,
		});
	}, [node, addIHKCertificateReward]);

	return (
		<Button
			className={"mr-2"}
			disabled={isAddingIHKCertificateReward || disabled}
			tooltipOptions={tooltipOptions}
			tooltip={t("educationalOffer.createIhkCertificateTooltip")}
			icon="pi pi-star"
			onClick={handleOnClick}
		/>
	);
};
